
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    export class PsConnectEdcPortGrid extends Serenity.EntityGrid<PsConnectEdcPortRow, any> {
        protected getColumnsKey() { return PsConnectEdcPortColumns.columnsKey; }
        protected getDialogType() { return PsConnectEdcPortDialog; }
        protected getIdProperty() { return PsConnectEdcPortRow.idProperty; }
        protected getInsertPermission() { return PsConnectEdcPortRow.insertPermission; }
        protected getLocalTextPrefix() { return PsConnectEdcPortRow.localTextPrefix; }
        protected getService() { return PsConnectEdcPortService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}